// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2ykG5","consentsList":"PatientConsents_consentsList__1_7RW","consentsListEmpty":"PatientConsents_consentsListEmpty__2R8x6"};